
import { Box, Typography } from '@mui/material';
import { useRef, useState } from 'react';
import { useEffect } from 'react';
import { getAdminUsers, postAdminCreateUser, } from '../../../data/hikoAdmin';
import { hikoException } from '../../../utils/HikoAlert';
import AlertLoading from '../../navigation/AlertLoading';
import { useContext } from 'react';
import { MahiContext } from '../../state/MahiContext';
import { UserRolesList } from './UserRolesList';
import { AddNewUser } from './AddNewUser'
import { DebugBox } from '@northpowerdev/np-react-utils';

export default function AdminListUsers() {

    const [pageLoading, setPageLoading] = useState(false)
    const [adminUsers, setAdminUsers] = useState()

    const mahiContext = useContext(MahiContext)

    const getAdminusersCallCounter = useRef(0)

    useEffect(() => {

        let didCancel = false;

        /**
         * @returns
         */
        const asyncGetUsers = async () => {
            setPageLoading(true)
            try {
                console.log('AdminListUsers COUNT calling getAdminUsers', getAdminusersCallCounter.current++)
                const allUsers = await getAdminUsers(mahiContext)
                console.log('AdminListUsers getAdminUsers done', {allUsers})
                if (!didCancel) {
                    setAdminUsers(allUsers)
                }
            } catch (e) {
                hikoException('Admin List Users Error', e)
            }
            if (!didCancel) {
                setPageLoading(false);
            }
        };

        console.log('AdminListUsers useEffect() calling asyncGetusers');
        asyncGetUsers();

        return (() => {didCancel = true})

    // lint expects mahiContext but this causes re-renders
    // eslint-disable-next-line
    }, []);

    /**
     * Saves new user i.e. create new user in back end
     * @param {object} userDetails {first, last, email}
     */
    const handleUserChanged = async (userDetails) => {
        console.log('AdminListUsers handleUserChanged userDetails', userDetails)
        let isSuccess = false;
        let createUserResponse = null;
        try {
            console.log('AdminListUsers calling postAdminUserRoles')
            createUserResponse = await postAdminCreateUser(mahiContext, userDetails)
            console.log('AdminListUsers postAdminUserRoles done - did not throw error createUserResponse', createUserResponse)
            isSuccess = true;
        } catch (e) {
            hikoException('Mahi Admin Failed To Create User', e)
        } finally {
            console.log('AdminListUsers finally clearing roles loading')
        }

        if (isSuccess) {
            console.log('AdminListUsers isSuccess true adding to list', createUserResponse)
            const newAdminUsers = adminUsers.concat([createUserResponse]);
            console.log('AdminListUsers isSuccess true newAdminUsers', newAdminUsers)
            setAdminUsers(newAdminUsers)
        }

    }

    const onUserEditComplete = (userDetails) => {

      // Update the users list, replacing the user that has been modified
      // so we can see our changes.

      const newAdminUsers = []

      for (let u of adminUsers) {
        if (u.id === userDetails.id) {
          newAdminUsers.push(userDetails)
        } else {
          newAdminUsers.push(u)
        }
      }

      setAdminUsers(newAdminUsers)
    }

    return (
        <Box className="Page">
            {/* <p>Users render {counter.current++}</p> */}
            <h2 className="np-title">Admin List Users</h2>
            <Typography variant="body1" paragraph>
                Maintain the list of Mahi users with contact details, network approved contractor selection and Mahi roles.
                Setting the contractor for a user controls the work they see in e.g. ICP Inspections.
            </Typography>

            <Box>
            {
            pageLoading
            ?
                <AlertLoading spinner={pageLoading} />
            :
            <>
                <UserRolesList users={adminUsers} onUserEditComplete={onUserEditComplete} />

                <AddNewUser userChanged={handleUserChanged} />

                <DebugBox>{JSON.stringify(adminUsers)}</DebugBox>
            </>
            }
            </Box>
        </Box>
    );
}